<script lang="ts">
    import { link } from 'svelte-spa-router';
    import KnowledgeSourceList from './knowledge/KnowledgeSourceList.svelte';
</script>

<div class="platform-knowledge-page">
    <nav class="knowledge-nav" aria-label="Knowledge sections">
        <span class="current">Platform</span>
        <a use:link href="/admin/knowledge/brief-types">Brief types</a>
        <a use:link href="/admin/knowledge/test">Test retrieval</a>
    </nav>

    <KnowledgeSourceList
        scope="platform"
        pageTitle="Platform knowledge"
        pageSubtitle="Xplorit-wide methodology, quality rules, and reference content for every AI request."
    />
</div>

<style>
    .knowledge-nav {
        display: flex;
        flex-wrap: wrap;
        gap: var(--space-3);
        margin-bottom: var(--space-4);
        font-size: var(--text-sm);
    }

    .knowledge-nav a {
        color: var(--primary);
        text-decoration: none;
        font-weight: 500;
    }

    .knowledge-nav a:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
    }

    .current {
        color: var(--grey);
        font-weight: 500;
    }
</style>
